import { useState, useEffect } from 'react';
import { getTicketAllocationSettings, calculateTicketAllocationLogic, TicketAllocationSettings, defaultSettings } from '../lib/ticketAllocationUtils';

export const useTicketAllocation = (eventId?: string) => {
  const [settings, setSettings] = useState<TicketAllocationSettings>(defaultSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, [eventId]);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const settingsData = await getTicketAllocationSettings(eventId);
      setSettings(settingsData);
    } catch (error) {
      console.error('Error fetching ticket allocation settings:', error);
      // Keep default values if fetch fails
    } finally {
      setLoading(false);
    }
  };

  const calculateTicketAllocation = (
    categories: any[],
    existingRegistrations: any[] = [],
    includeToolCar: boolean = false,
    toolCarCount: number = 0
  ) => {
    return calculateTicketAllocationLogic(
      categories,
      existingRegistrations,
      includeToolCar,
      toolCarCount,
      settings
    );
  };

  return {
    settings,
    loading,
    fetchSettings,
    calculateTicketAllocation
  };
};